import { axiosAccountInstance } from "api/Request";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";

import toast from "../../../../../components/Toastify";
import { setSowInfo } from "redux/actions/admin/SowActions";
import Tables from "views/examples/Tables";
import viewIcn from "../../../../../assets/img/icons/customIcons/view.svg";

import { fetchUserData } from "helpers/storageData";

// import rejectIcn from "../../../../../assets/img/icons/customIcons/reject.svg";
import BookingModal from "components/Modals/BookingModal";
import SOWUploadModal from "components/Modals/SOWUploadModal";

function PendingSOWApprovalCard({ loader }) {
  const dispatch = useDispatch();
  const [sowHistory, setSOWHistory] = useState([]);
  const [modal, setModal] = useState(false);
  const [sowModal, setSOWModal] = useState(false);
  const [data, setData] = useState([]);
  const [employeeID, setEmployeeID] = useState("");
  const [errors, setErrors] = useState(null);
  const [rejectRequestReason, setRejectRequestReason] = useState("");
  const [bookingData, setBookingData] = useState({});
  const [bookingModal, setBookingModal] = useState(false);
  const [sowData, setSOWData] = useState([]);
  const [approveFormData, setApproveFormData] = useState({
    _id: null,
    sow_status: null,
    sowDocument: null,
  });
  const PendingSOWApprovalList = useSelector(
    (state) => state.SowReducer.result
  );

  useEffect(() => {
    setData(PendingSOWApprovalList.booking || []);
  }, [PendingSOWApprovalList]);

  const handleOnChange = (e) => {
    if (e.target.value) {
      setIsRejectButtonDisabled(false);
    }

    setRejectRequestReason(e.target.value);
    setErrors({ ...errors, rejectRequestReason: null });
  };

  // const rejectHandler = (id) => {
  //   setEmployeeID(id);
  //   setModal(!modal);
  // };
  const close = () => {
    setRejectRequestReason("");
    setSOWModal(false);
    setModal(false);
    setBookingModal(false);
    setErrors({ ...errors, sowDocument: null });
  };

  const validation = (data) => {
    const errorsFound = {};

    if (!rejectRequestReason || rejectRequestReason === "") {
      errorsFound["rejectRequestReason"] = "Reject Request Reason is required";
    }

    if (Object.keys(errorsFound).length !== 0) {
      setErrors(errorsFound);
      return false;
    }
    return true;
  };
  const socketInstance = useSelector((state) => state.socketReducer.result);

  const setCompanyApproval = (isValid = true, data, requesttype) => {
    if (isValid) {
      axiosAccountInstance
        .post("/booking/sow_request/approve", data)
        .then((res) => {
          if (res.data.statusCode === 200) {
            if (requesttype === "approved") {
              socketInstance.emit("message", {
                type: "UPDATE_BOOKING",
                subType: "UPDATE_SOW_APPROVED_REQUEST_LIST",
                key: data.get("_id"),
                extraInfo: fetchUserData()?.companyName,
              });
              toast.success(res.data.body.message);
            } else {
              socketInstance.emit("message", {
                type: "UPDATE_BOOKING",
                subType: "UPDATE_SOW_REJECTED_REQUEST_LIST",
                key: data?._id,
                extraInfo: fetchUserData()?.companyName,
              });
              toast.success(res.data.body.message);
            }
            setSOWModal(false);
            dispatch(setSowInfo("0", "1", "sowPending", null, "pending"));

            setModal(false);
          }
        })
        .catch((err) => {
          toast.error(err.response.data.body.message);
        });
      setRejectRequestReason("");
    }
  };
  const setCompanyApprovalSOW = (isValid = true, data, requesttype) => {
    if (isValid) {
      axiosAccountInstance
        .post("/booking/sow_request/approve", data)
        .then((res) => {
          if (res.data.statusCode === 200) {
            if (requesttype === "approved") {
              socketInstance.emit("message", {
                type: "UPDATE_BOOKING",
                subType: "UPDATE_SOW_APPROVED_REQUEST_LIST",
                key: data.get("_id"),
                extraInfo: fetchUserData()?.companyName,
              });
              toast.success(res.data.body.message);
            } else {
              socketInstance.emit("message", {
                type: "UPDATE_BOOKING",
                subType: "UPDATE_SOW_REJECTED_REQUEST_LIST",
                key: data?._id,
                extraInfo: fetchUserData()?.companyName,
              });

              toast.success(res.data.body.message);
            }
            setSOWModal(false);
            dispatch(setSowInfo("0", "1", "sowPending", null, "pending"));

            setModal(false);
          }
        })
        .catch((err) => {
          toast.error(err.response.data.body.message);
        });
      setRejectRequestReason("");
    }
  };
  const submitRequest = (data, type) => {
    if (data.sow_status === "rejected") {
      const isValid = validation(data);
      setCompanyApproval(isValid, data, type);
    } else {
      setCompanyApproval(true, data, type);
    }
  };
  const submitRequestSOW = (data, type) => {
    if (data.sow_status === "rejected") {
      const isValid = validation(data);
      setCompanyApprovalSOW(isValid, data, type);
    } else {
      setCompanyApprovalSOW(true, data, type);
    }
  };
  const [isRejectButtonDisabled, setIsRejectButtonDisabled] = useState(false); //multiple click disabled
  const [isApproveButtonDisabled, setIsApproveButtonDisabled] = useState(true); //multiple click disabled
  // console.log("isApproveButtonDisabled",isApproveButtonDisabled)
  const onApproveSOW = async () => {
    setIsApproveButtonDisabled(true);
    const finalData = approveFormData;
    if (!finalData?.sowDocument) {
      setErrors({ ...errors, sowDocument: "SOW document required" });
    } else {
      const data = new FormData();
      data.append("_id", sowData?._id);
      data.append("sowDocument", finalData?.sowDocument);
      data.append("sow_status", sowData?.sow_status);
      submitRequestSOW(data, "approved");
    }
  };

  const onReject = () => {
    setIsRejectButtonDisabled(true);
    const finalData = {
      _id: employeeID,
      sow_status: "rejected",
      rejectReason: rejectRequestReason,
    };
    submitRequest(finalData, "rejected");
  };

  const viewHandler = (dataObj) => {
    setBookingData(dataObj);
    setBookingModal(true);
  };
  const sowRequestHandler = (id, data) => {
    console.log("sow data  ", data);
    setSOWModal(!sowModal);
    setSOWData(data);
    setEmployeeID(id);
    setSOWHistory(data?.activity?.filter((obj) => obj.action.includes("SOW")));
  };

  const colums = [
    { columnName: "Employee Name", columnTag: "name", type: "data" },

    // { columnName: "Company", columnTag: "bookedCompany", type: "data" },
    { columnName: "Employee ID", columnTag: "empId", type: "data" },
    { columnName: "Designation", columnTag: "designation", type: "data" },
    { columnName: "Date Range", columnTag: "duration", type: "objectData" },
    {
      columnName: "Hourly Rate",
      columnTag: "hourlyPayment",
      type: "paymentMapping",
    },

    {
      columnName: "SOW",
      columnTag: "sow_final_status",
      type: "data",
      actionSOWApprove: sowRequestHandler,
    },

    { columnName: "Status", columnTag: "status", type: "data" },
    { columnName: "", columnTag: "", type: " " },
  ];
  const actionButtons = [
    {
      columnName: "",
      btnTitle: "View",
      type: "actionButton",
      btn: "ViewBooking",
      btnType: "primary",
      btnTooltip: "View",
      btnIcon: viewIcn,
      actionFunction: viewHandler,
    },
    // {
    //   columnName: "",
    //   type: "actionButton",
    //   btnTitle: "Approve",
    //   btnIcon: approveIcn,
    //   btnTooltip: "Approve",
    //   btnType: "primary",
    //   btn: "SowApproval",
    //   actionFunction: onApprove,
    // },
    // {
    //   columnName: "",
    //   btnTitle: "Reject",
    //   type: "actionButton",
    //   btnIcon: rejectIcn,
    //   btnTooltip: "Reject",
    //   btn: "SowReject",
    //   btnType: "danger",
    //   actionFunction: rejectHandler,
    // },
  ];

  const imageSelect = (image) => {
    if (image) {
      setIsRejectButtonDisabled(false);
    }

    const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB maximum size limit
    if (image.size > MAX_IMAGE_SIZE) {
      setErrors({
        ...errors,
        sowDocument: `File size exceeds the maximum limit of ${
          MAX_IMAGE_SIZE / (1024 * 1024)
        }MB`,
      });
      setApproveFormData({
        ...approveFormData,
        sowDocument: null,
      });
      setIsApproveButtonDisabled(true);
    } else {
      setErrors({ ...errors, sowDocument: null });
      setApproveFormData({
        ...approveFormData,
        sowDocument: image,
      });
      setIsApproveButtonDisabled(false);
    }
    // setErrors({ ...errors, sowDocument: null });
    // setApproveFormData({
    //   ...approveFormData,
    //   sowDocument: image,
    // });
    // setIsApproveButtonDisabled(false);
  };
  return (
    <div>
      {data && (
        <Tables
          coloums={colums}
          data={PendingSOWApprovalList?.booking}
          actionButtons={actionButtons}
          loader={loader}
        />
      )}

      <SOWUploadModal
        sowModal={sowModal}
        close={close}
        onApproveSOW={onApproveSOW}
        sowHistory={sowHistory}
        isApproveButtonDisabled={isApproveButtonDisabled}
        errors={errors}
        imageSelect={imageSelect}
        sowData={sowData}
      />
      <Modal toggle={close} centered isOpen={modal}>
        <Row>
          <div className="col">
            <ModalHeader className="text-uppercase font-weight-bolder">
              Reject Booking
            </ModalHeader>
          </div>
          <Row>
            <Col>
              <ModalHeader className="text-uppercase">
                <Button onClick={close} className="mx-1" close />
              </ModalHeader>
            </Col>
          </Row>
        </Row>
        <ModalBody>
          <label className="font-weight-normal">
            Do you want to reject the booking request?
          </label>
          <FormGroup row>
            <Label for="exampleText" sm={12}>
              Rejection Remarks
            </Label>
            <Col sm={12}>
              <Input
                id="exampleText"
                name="text"
                type="textarea"
                onChange={handleOnChange}
                value={rejectRequestReason}
                invalid={!!errors && !!errors.rejectRequestReason}
              />
              <FormFeedback
                className={errors?.rejectRequestReason && "invalid-field"}
              >
                {errors?.rejectRequestReason}
              </FormFeedback>
            </Col>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            onClick={() => onReject()}
            color="primary"
            disabled={isRejectButtonDisabled}
          >
            Submit
          </Button>{" "}
          {/* <Button size="sm" onClick={close}>
                  Cancel
                </Button> */}
        </ModalFooter>
      </Modal>
      <BookingModal modal={bookingModal} close={close} data={bookingData} />
    </div>
  );
}

export default PendingSOWApprovalCard;
